/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{Material as r}from"../lib/Material.js";import{intersectTriangleGeometry as t}from"../lib/RayIntersections.js";class e extends r{intersect(r,e,i,s,o,n){return t(r,i,s,o,void 0,n)}}export{e as TriangleMaterial};
